<template>
  <div id="app">
    <div class="app-route-surface" :inert="pageLoad.status !== 'idle' ? '' : null" :aria-busy="pageLoad.status === 'loading' ? 'true' : 'false'">
      <router-view />
    </div>
    <section v-if="pageLoad.status !== 'idle'" class="app-page-load" :class="'ui-feedback-theme--' + feedbackTheme" :aria-label="pageLoad.title">
      <div class="app-page-load__card ui-feedback-card">
        <i v-if="pageLoad.status === 'loading'" class="el-icon-loading ui-loading-spinner" aria-hidden="true"></i>
        <i v-else class="el-icon-warning-outline" aria-hidden="true"></i>
        <div :role="pageLoad.status === 'error' ? 'alert' : 'status'" aria-live="polite">
          <h1>{{ pageLoad.title }}</h1>
          <p>{{ pageLoad.detail }}</p>
          <p v-if="pageLoad.slow" class="app-page-load__hint">请求耗时较长，仍在等待服务器响应，请稍候。超时后可重试。</p>
        </div>
        <div v-if="pageLoad.status === 'error'" class="app-page-load__actions">
          <button ref="retry" type="button" @click="retryPage">重新加载页面</button>
          <button v-if="$route.name" type="button" @click="dismissLoad">返回当前页面</button>
          <button v-else type="button" @click="$router.replace('/login')">前往登录</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { pageLoadFeedback } from '@/runtime/page-load-feedback'
export default {
  name: 'app',
  data () { return { pageLoad: pageLoadFeedback.state } },
  computed: {
    feedbackTheme () { return /^\/(?:home|login)(?:[/?]|$)/.test(this.pageLoad.target || this.$route.path) || (this.pageLoad.target || this.$route.path) === '/' ? 'light' : 'dark' }
  },
  watch: {
    'pageLoad.status' (status) {
      if (status === 'error') this.$nextTick(() => { if (this.$refs.retry) this.$refs.retry.focus({ preventScroll: true }) })
    }
  },
  methods: {
    retryPage () {
      this.$router.replace(this.pageLoad.target || '/home').catch(() => {})
    },
    dismissLoad () { pageLoadFeedback.dismiss() }
  }
}
</script>

<style>
@import "~@/styles/fonts/font.css";
@import "~@/styles/management-dialog.css";
.app-route-surface { width: 100%; height: 100%; min-height: 0; }
.app-page-load { position: fixed; inset: 0; z-index: 30000; display: grid; place-items: center; box-sizing: border-box; padding: 24px; background: var(--feedback-bg); color: var(--feedback-text); }
.app-page-load__card > .el-icon-warning-outline { font-size: 30px; color: var(--feedback-accent); }
.app-page-load .app-page-load__hint { font-size: 12px; }
.app-page-load__actions { display: flex; flex-wrap: wrap; justify-content: center; gap: 10px; margin-top: 20px; }
@media (prefers-reduced-motion: reduce) { .app-page-load .el-icon-loading { animation: none; } }
</style>
